import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_FETCH } from "../General/Utility";
import ReactTable from "../General/ReactTable";

// LOCAL date (yyyy-MM-dd). toISOString() returns the UTC date, which is the
// previous day in India between 12:00 AM and 5:30 AM.
const GetToday = () => {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
};

function JournalView(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);

  const [ListEntJournal, setListEntJournal] = useState([]);
  const [strFromDate, setstrFromDate] = useState(GetToday());
  const [strToDate, setstrToDate] = useState(GetToday());
  const [strDateError, setstrDateError] = useState("");

  const iRequestRef = useRef(0); // ignores out-of-order API responses
  const bUnmountedRef = useRef(false);

  useEffect(() => {
    Load_JournelEntry(strFromDate, strToDate);
    return () => {
      bUnmountedRef.current = true;
    };
  }, []);

  // Esc closes the popup
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") props.Close();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const Load_JournelEntry = async (FromDate, ToDate) => {
    const iRequest = ++iRequestRef.current;
    const res = await API_FETCH(
      "JournalEntry/Load_JournelEntry/" +
        FromDate +
        "/" +
        ToDate +
        "/" +
        Number(props.BranchId || _AuthParems?.Branch) +
        "/" +
        (props.DBName || _AuthParems?.DB),
      dispatch
    );
    if (bUnmountedRef.current || iRequest !== iRequestRef.current) return;
    if (res) {
      setListEntJournal(res.EntJournel || []);
    }
  };

  const DateOnChange = (value, DateFor) => {
    const From = DateFor === "FromDate" ? value : strFromDate;
    const To = DateFor === "FromDate" ? strToDate : value;
    if (DateFor === "FromDate") setstrFromDate(value);
    else setstrToDate(value);

    if (!From || !To) {
      setstrDateError("Please select both From Date and To Date");
      return;
    }
    if (From > To) {
      setstrDateError("From Date cannot be greater than To Date");
      return;
    }
    setstrDateError("");
    Load_JournelEntry(From, To);
  };

  const JEColumn = [
    {
      Header: "SNO",
      accessor: "sNo",
      maxWidth: 70,
    },
    {
      Header: "Trans No",
      accessor: "transNo",
      minWidth: 200,
    },
    {
      Header: "Voucher No",
      id: "jeId",
      accessor: "jeNo",
      minWidth: 200,
    },
    {
      Header: "Trans Date",
      accessor: "jeDate",
      minWidth: 200,
    },
    {
      Header: "Debit",
      accessor: "dr",
      Datatype: "Decimal",
    },
    {
      Header: "Credit",
      accessor: "cr",
      Datatype: "Decimal",
    },
  ];

  return (
    <div
      className="popup-container"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) props.Close(); // click on backdrop
      }}
    >
      <div className="popup-content">
        <div className="popup-header">
          <h5>Journal View</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={props.Close} title="Close">
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        {/* INTERIM scroll fix - remove once popup CSS is corrected */}
        <div
          className="popup-body"
          style={{ maxHeight: "calc(100vh - 140px)", overflowY: "auto" }}
        >
          <div className="row">
            <div className="col-md-3 col-sm-12 mb-1">
              <label>From Date</label>
              <input
                type="date"
                aria-label="From Date"
                className="form-control"
                value={strFromDate}
                max={strToDate || undefined}
                onChange={(e) => DateOnChange(e.target.value, "FromDate")}
              />
            </div>
            <div className="col-md-3 col-sm-12 mb-1">
              <label>To Date</label>
              <input
                type="date"
                aria-label="To Date"
                className="form-control"
                value={strToDate}
                min={strFromDate || undefined}
                onChange={(e) => DateOnChange(e.target.value, "ToDate")}
              />
            </div>
            {strDateError !== "" && (
              <div className="col-md-6 col-sm-12 mb-1 d-flex align-items-end">
                <small style={{ color: "#dc3545" }}>{strDateError}</small>
              </div>
            )}
          </div>
          <ReactTable
            columns={JEColumn}
            data={ListEntJournal}
            minRows={7}
            row_click={() => {}}
            row_doubleclick={(rowInfo) => {
              props.JournalView(rowInfo.jeId);
            }}
            background={true}
            className="full-table"
          />
        </div>
      </div>
    </div>
  );
}
export default JournalView;